/**
 * 数値をパーセント形式の文字列に変換する
 *
 * @description 数値にパーセント記号を付加した文字列に変換する
 *
 * @param {number} rate - 数値（0-100）
 * @returns {string} パーセント形式の文字列（例: "75%"）
 *
 * @example
 * formatRateAsPercent(75);  // "75%"
 * formatRateAsPercent(0);   // "0%"
 * formatRateAsPercent(100); // "100%"
 */
export function formatRateAsPercent(rate: number): string {
  return `${rate}%`;
}
